import { TShopState } from '@/redux/reducers/shop';
import { TGetShopsSuccess } from '@/redux/actions/shop';

export const getShopsUpdateState = (state: TShopState, action: TGetShopsSuccess): TShopState => ({
  ...state,
  getShopsResponse: action.payload.response,
});
